export const AAT_IM_APIMapping = {
  USER: 'users',
  USER_BY_AUTH0_ID: 'users/:auth0Id',
  CLEAR_DEVICE: 'users/:auth0Id/clearDevice',
  DEVICE_HISTORY: 'users/:auth0Id/device-history',
  INVITE_PERSONAS: 'invite/personas',
  INVITE_SEND: 'invite/send'
}
